import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d199b42a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination-details" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
  total: number;
  from: number;
  to: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationDetails',
  props: {
    total: null,
    from: null,
    to: null
  },
  setup(__props: any) {

const props = __props as {
  total: number;
  from: number;
  to: number;
}

const { t } = useI18n();



const text = computed(() => {
  return t('components.pagination.details', props);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(text)), 1))
}
}

})